import { defineStore } from "pinia";
import { ref } from "vue";

import useTeamPicker from "shared/composables/useTeamPicker";
import { getCurrentTimestamp } from "shared/helpers/date";
import { MediaRequest } from "shared/resources";
import features from "shared/services/features";
import useUserStore from "shared/stores/user";

export const useMediaRequestsStore = defineStore("mediaRequests", () => {
  const newMediaRequestsCount = ref<number>(0);

  async function fetchNewMediaRequestsCount() {
    try {
      const response = await MediaRequest.where({
        completedAt: { gt: useUserStore().currentUser.media_requests_seen_at },
        ...(features.has("has_team_workspaces")
          ? {
              organisationTeamId: [
                useTeamPicker().selectedTeamPreference.value,
                "null",
              ],
            }
          : {}),
      })
        .per(0)
        .page(1)
        .stats({ total: "count" })
        .all();

      newMediaRequestsCount.value = response.meta.stats.total.count;
    } catch {
      // do nothing
    }
  }

  function clearMediaItemAlertsCount() {
    newMediaRequestsCount.value = 0;

    return useUserStore().updateUser({
      media_requests_seen_at: getCurrentTimestamp(),
    });
  }

  return {
    clearMediaItemAlertsCount,

    fetchNewMediaRequestsCount,
    newMediaRequestsCount,
  };
});
